import React, { useEffect } from "react";

import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";
import { translations } from "../../i18n/i18n";
NativeFancybox.defaults.Hash = false;

function Fancybox(props) {
	const delegate = props.delegate || "[data-fancybox]";

	useEffect(() => {
		const opts = props.options || {};

		NativeFancybox.defaults.l10n = translations.fancybox;
		NativeFancybox.bind(delegate, {
			...opts,

		});

		return () => {
			NativeFancybox.destroy();
		};
	}, []);

	return <>{props.children}</>;
}

export default Fancybox;